import React, { useState } from 'react';
import ScanViewer from '../Scan/ScanViewer';

const GuestScanViewer = ({ scan }) => {
  const [showContactMessage, setShowContactMessage] = useState(false);

  const handleDocumentClick = () => {
    setShowContactMessage(true);
  };

  const getIcon = (type) => {
    switch (type) {
      case 'pdf':
        return (
          <svg className="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
          </svg>
        );
      case 'dwg':
        return (
          <svg className="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        );
      default:
        return (
          <svg className="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        );
    }
  };

  return (
    <div className="p-6 space-y-6">
      <h2 className="text-xl font-semibold text-gray-900">
        Escaneo del {scan.date}
      </h2>
      <ScanViewer embedCode={scan.embedCode} />
      
      <div className="mt-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Documentos relacionados</h3>
        <div className="space-y-3">
          {scan.documents.map((doc) => (
            <button
              key={doc.id}
              onClick={handleDocumentClick}
              className="flex items-center p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors w-full text-left"
            >
              {getIcon(doc.type)}
              <span className="ml-3 text-gray-700">{doc.name} ({doc.type.toUpperCase()})</span>
            </button>
          ))}
        </div>
        {showContactMessage && (
          <p className="mt-4 text-sm text-gray-600">
            Para acceder a estos documentos, por favor contacta a <a href="mailto:contacto@samins.pe" className="text-blue-600 hover:underline">contacto@samins.pe</a>.
          </p>
        )}
      </div>
    </div>
  );
};

export default GuestScanViewer;

// DONE